/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from "@angular/common/http";
import {Observable} from "rxjs";
import {StrictHttpResponse} from "../../strict-http-response";
import {RequestBuilder} from "../../request-builder";
import {filter, map} from "rxjs/operators";
import {FilePostModel} from "../../models/file-post-model";

export interface FilesPostParams {
    body: FilePostModel
}

export function filesPost(http: HttpClient, rootUrl: string, params: FilesPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(rootUrl, filesPost.PATH, 'post');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.body(params.body, 'multipart/form-data');

    return http.request(
        rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<string>;
        })
    );
}

filesPost.PATH = '/api/v1/files';
